import React, { useEffect, useState } from "react";
import GlobalWrapper from "../../../components/Wrapper/GlobalWrapper";
import { Alert, Box, Chip, Grid, Table, TableBody, TableCell, TableHead, TableRow, Typography } from "@mui/material";
import { useDispatch } from "react-redux";
import FromAndToDatePicker from "../../../components/mui/FromAndToDatePicker";
import dayjs from "dayjs";
import Loader3D from "../../../components/Loader/Loader3D";
import { useSelector } from "react-redux";
import AssetDashcard from "./AssetDashcard";
import { Icon } from "@iconify/react/dist/iconify.js";
import { getAllProductsCount, getChartdata, getDashboardData } from "../../../redux/features/assetManagementSlice";
import { BarChart, Search } from "@mui/icons-material";
import { Bar } from "react-chartjs-2";
import Searchbar from "../../../components/Search/Searchbar";

const AssetDashboard = () => {
  const { loading, dashboardData, allProductsCount, chartData } = useSelector((state) => state.assetmanagement);

  const dispatch = useDispatch();

  const [value, setValue] = useState("");

  const data = {
    search: value || "",
  };

  useEffect(() => {
    dispatch(getDashboardData());
    dispatch(getChartdata());
  }, []);

  useEffect(() => {
    dispatch(getAllProductsCount(data));
  }, [value]);

  const headers = ["Item", "Category", "Current Stock"];

  const headersOfProducts = ["Item", "Category", "Available", "Damaged", "In Use", "Total", "Value"];

  return (
    <GlobalWrapper title={"Asset Overview & Insights"}>
      <Box
        sx={{
          marginTop: 5,
        }}
      >
        <Box>
          <Grid container spacing={2}>
            <Grid item xs={12} md={4} sm={4}>
              <AssetDashcard
                count={dashboardData?.finalSummary?.activeProducts}
                icon="lets-icons:bag"
                title="TOTAL PRODUCTS"
                gradient="linear-gradient(to right, #77567A, #C47AC0)"
                color="#77567A"
                productStatus={"All"}
              />
            </Grid>
            <Grid item xs={12} md={4} sm={4}>
              <AssetDashcard
                count={dashboardData?.finalSummary?.totalDamagedCount}
                icon="fluent:text-bullet-list-square-warning-16-regular"
                title="DAMAGED PRODUCTS"
                gradient="linear-gradient(to right, #ff7b00, #ffb700)"
                color="#ff7b00"
                productStatus={"Damaged"}
              />
            </Grid>
            <Grid item xs={12} md={4} sm={4}>
              <AssetDashcard
                count={dashboardData?.finalSummary?.totalSaledCount}
                icon="solar:sale-linear"
                title="DELIVERED PRODUCTS"
                gradient="linear-gradient(to right, #0d47a1, #1e88e5)"
                color="#0d47a1"
                productStatus={"InStock"}
              />
            </Grid>
            {/* <Grid item xs={12} md={6} sm={6}>
                  <AssetDashcard
                    count={dashboardData?.finalSummary?.inactiveProducts}
                    icon="fluent:delete-dismiss-20-regular"
                    title="INACTIVE PRODUCTS"
                    gradient="linear-gradient(to right, #774936, #9d6b53)"
                    color="#774936"
                    productStatus={"deleted"}
                    navigation={true}
                  />
                </Grid> */}
          </Grid>
          <Grid container spacing={2} paddingBottom={4}>
            <Grid item xs={12} sm={12} md={5}>
              <Box
                sx={{
                  boxShadow: " rgba(17, 17, 26, 0.1) 0px 0px 16px;",
                  width: "100%",
                  borderRadius: "15px",
                  padding: "15px",
                }}
              >
                <Box
                  sx={{
                    borderBottom: "1px dotted gray",
                    width: "100%",
                    py: "10px",
                  }}
                >
                  <Typography
                    sx={{
                      color: "#77567A",
                      fontWeight: 700,
                      textTransform: "uppercase",
                    }}
                  >
                    Low Stock Items
                  </Typography>
                </Box>
                <Table
                  aria-label="simple table"
                  sx={{
                    border: "none",
                    borderCollapse: "separate",
                    marginTop: 2,
                  }}
                >
                  <TableHead
                    sx={{
                      display: "table",
                      width: "100%",
                      tableLayout: "fixed",
                    }}
                  >
                    <TableRow sx={{ backgroundColor: "#77567A", color: "#fff" }}>
                      {headers.map((header, index) => (
                        <TableCell
                          key={index}
                          align="left"
                          sx={{
                            border: "none",
                            color: "#fff",
                            ...(index === 0 && {
                              borderTopLeftRadius: "12px",
                            }),
                            ...(index === headers.length - 1 && {
                              borderTopRightRadius: "12px",
                            }),
                          }}
                        >
                          {header}
                        </TableCell>
                      ))}
                    </TableRow>
                  </TableHead>
                </Table>
                {dashboardData?.lowStockProducts?.length === 0 && (
                  <Alert severity="info" sx={{ mt: 1 }}>
                    No low stock items
                  </Alert>
                )}
                <Box sx={{ maxHeight: 300, overflowY: "auto" }}>
                  <Table
                    sx={{
                      borderCollapse: "separate",
                      display: "block",
                    }}
                  >
                    <TableBody
                      sx={{
                        display: "table",
                        width: "100%",
                        tableLayout: "fixed",
                      }}
                    >
                      {dashboardData?.lowStockProducts?.map((item) => (
                        <TableRow sx={{ backgroundColor: "#fff" }} key={item.productId}>
                          <TableCell align="left" sx={{ border: "none" }}>
                            {item.subCategoryName}
                          </TableCell>
                          <TableCell align="left" sx={{ border: "none" }}>
                            {item.categoryName}
                          </TableCell>
                          {/* <TableCell align="left" sx={{ border: "none" }}>
                            {item.minimumStockQuantity}
                          </TableCell> */}
                          <TableCell align="left" sx={{ border: "none" }}>
                            {item.currentStock}
                          </TableCell>
                        </TableRow>
                      ))}
                    </TableBody>
                  </Table>
                </Box>
              </Box>
            </Grid>
            <Grid item xs={12} sm={12} md={7}>
              <Box
                sx={{
                  boxShadow: " rgba(17, 17, 26, 0.1) 0px 0px 16px;",
                  width: "100%",
                  borderRadius: "15px",
                  padding: "15px",
                }}
              >
                <Box
                  sx={{
                    borderBottom: "1px dotted gray",
                    width: "100%",
                    py: "10px",
                    display: "flex",
                    justifyContent: "space-between",
                    alignItems: "flex-start",
                    flexDirection: { xs: "column", sm: "row" },
                  }}
                >
                  <Typography
                    sx={{
                      color: "#000",
                      fontWeight: 700,
                      textTransform: "uppercase",
                      mb: { xs: 1, sm: 0 },
                      mr: 2,
                    }}
                  >
                    Inventory
                  </Typography>
                  <Searchbar value={value} setValue={setValue} label={"Search Item"} fontSize={"5px"} />
                </Box>
                <Table
                  aria-label="simple table"
                  sx={{
                    border: "none",
                    borderCollapse: "separate",
                    marginTop: 2,
                  }}
                >
                  <TableHead
                    sx={{
                      display: "table",
                      width: "100%",
                      tableLayout: "fixed",
                    }}
                  >
                    <TableRow sx={{ backgroundColor: "#000", color: "#fff" }}>
                      {headersOfProducts.map((header, index) => (
                        <TableCell
                          key={index}
                          align="left"
                          sx={{
                            border: "none",
                            color: "#fff",
                            ...(index === 0 && {
                              borderTopLeftRadius: "12px",
                            }),
                            ...(index === headersOfProducts.length - 1 && {
                              borderTopRightRadius: "12px",
                            }),
                          }}
                        >
                          {header}
                        </TableCell>
                      ))}
                    </TableRow>
                  </TableHead>
                </Table>
                {allProductsCount?.length === 0 && (
                  <Alert severity="info" sx={{ mt: 1 }}>
                    No Items
                  </Alert>
                )}
                <Box sx={{ maxHeight: 300, overflowY: "auto" }}>
                  <Table
                    sx={{
                      borderCollapse: "separate",
                      display: "block",
                    }}
                  >
                    <TableBody
                      sx={{
                        display: "table",
                        width: "100%",
                        tableLayout: "fixed",
                      }}
                    >
                      {allProductsCount?.map((item) => (
                        <TableRow sx={{ backgroundColor: "#fff" }} key={item.sub_category_id}>
                          <TableCell align="left">{item.sub_category_name}</TableCell>
                          <TableCell align="left">{item.category_name}</TableCell>
                          <TableCell align="center">
                            {item.available === 0 ? <Chip variant="contained" color="error" label={item.available} /> : item.available}
                          </TableCell>
                          <TableCell align="center">{item.damaged}</TableCell>
                          <TableCell align="center">{item.sold}</TableCell>
                          <TableCell align="center">{item.total}</TableCell>
                          <TableCell align="center">{item?.stockValue}</TableCell>
                        </TableRow>
                      ))}
                    </TableBody>
                  </Table>
                </Box>
              </Box>
            </Grid>
          </Grid>

          <Grid container spacing={2}>
            <Grid item xs={12} sm={12}>
              <Box
                sx={{
                  boxShadow: " rgba(17, 17, 26, 0.1) 0px 0px 16px;",
                  width: "100%",
                  borderRadius: "15px",
                  padding: "20px",
                }}
              >
                <Typography
                  sx={{
                    fontWeight: 700,
                    color: "#000",
                    textTransform: "uppercase",
                    marginBottom: "20px",
                  }}
                >
                  Departmental Allocation Overview
                </Typography>
                <Bar
                  data={{
                    labels: chartData.map((data) => data.departmentName),
                    datasets: [
                      {
                        label: "Item Count",
                        backgroundColor: chartData.map((_, index) => ["#E2C2C6", "#B9929F", "#9C528B", "#610F7F", "#2F0147"][index % 5]),
                        borderRadius: 5,
                        data: chartData.map((data) => data.itemCount),
                      },
                    ],
                  }}
                  options={{
                    plugins: {
                      legend: {
                        display: false, // Hides the legend
                      },
                    },
                  }}
                />
              </Box>
            </Grid>
          </Grid>
        </Box>
      </Box>
    </GlobalWrapper>
  );
};

export default AssetDashboard;
